import { Component } from 'react';
import styled from 'styled-components';
import ModuleTitleLinkAnchor, { IModuleTitleLinkAnchorProps as IProps } from './ModuleTitleLinkAnchor';

interface IDefaultProps {
  linkTargetBlank: boolean;
}

const LinkList = styled.ul`
  display: flex;
  align-items: center;
  margin-right: -8px;
  font-weight: bold;
`;

const LinkItem = styled.li`
  position: relative;

  & + & {
    &::before {
      position: absolute;
      top: 50%;
      display: block;
      width: 1px;
      height: 16px;
      content: '';
      background-color: ${props => props.theme.news.palette.bor_lv2_pc};
      transform: translateY(-50%);
    }
  }
`;

export default class ModuleTitleLink extends Component<Omit<IProps, 'isCurrent'>> {
  public static defaultProps: IDefaultProps = {
    linkTargetBlank: false
  };
  /**
   *
   */
  public render() {
    return (
      <LinkList>
        <LinkItem>
          <ModuleTitleLinkAnchor
            linkURL={this.props.linkURL}
            dataClParams={this.props.dataClParams}
            linkText={this.props.linkText}
            linkTargetBlank={this.props.linkTargetBlank}
            isCurrent={false}
          />
        </LinkItem>
      </LinkList>
    );
  }
}
